import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MessagingService } from 'src/app/services/messaging.service';
import { FileManagerService } from '../../file-manager/file-manager.service';
import { ItemFilterPipe } from 'src/app/pipes/item-filter.pipe';
import { TdoOrganizerSlideshowDialogComponent } from 'src/app/main-interface/organizer/dialogs/tdo-organizer-slideshow-dialog/tdo-organizer-slideshow-dialog.component';

@Component({
  selector: 'app-patient-portal-correspondence',
  templateUrl: './patient-portal-correspondence.component.html',
  styleUrls: ['./patient-portal-correspondence.component.scss']
})
export class PatientPortalCorrespondenceComponent {

  activeAppointmentId: any;
  appointments: any[];
  patientId: string;

        
  constructor(
    public dialogRef: MatDialogRef<PatientPortalCorrespondenceComponent>,
    private readonly messagingService: MessagingService,
    private readonly fileManagerService: FileManagerService,
    private readonly itemFilterPipe: ItemFilterPipe,
    private readonly dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.activeAppointmentId = this.data.activeAppointmentId;
    this.appointments = this.data.appointments;
    this.patientId = this.data.patientId;
  }

  toggleCorrespondence (appointmentId){

    if (this.activeAppointmentId === appointmentId)
      this.activeAppointmentId = null;
    else
    this.activeAppointmentId = appointmentId;
  }

  close() {
    this.dialogRef.close();
  }

  expandAll(event: MatCheckboxChange){
    if (event.checked) 
      this.activeAppointmentId = "all";
    else
    this.activeAppointmentId = "";
  }

  openReport(report:any){
      console.log("Opening report:", report);
  
        let documentIds: string[] = [];
        documentIds.push(report.DocumentID);
    
        const config = new MatDialogConfig();
        config.panelClass = 'standard-dialog';
        config.data = documentIds;
        config.maxWidth = '100vw';
        config.maxHeight = '100vh';
        config.width = '98%';
        config.height = '98%';
        console.log('ReferrerPortalReferralDetailComponent openReport:', config);
        this.dialog.open(TdoOrganizerSlideshowDialogComponent, config).afterClosed().subscribe((res) => {
          //
        });    
    }
  openCorrespondenceFile(file){

    this.openReport(file);

    /*
    let windowOptions = [
      'toolbar=no',
      'location=no',
      'menubar=no',
      'height=' + screen.height,
      'width=' + screen.width,
      'fullscreen=yes' // only works in IE, but here for completeness
    ].join(',');
    const fileSource = this.fileManagerService.getDocumentImageUrl(this.patientId, file.DocumentFileName);
    this.messagingService.openPopUpWindow(fileSource, windowOptions, file.DocumentFileName, "", null, true, file.DocumentFileName);
    */
  }

  ContainsAppointmentCorrespondence(appointment: any) {
    return appointment.correspondence.length>0;
  }
}
